import React, { useState, useEffect } from 'react';
import { Row, Col, Typography, Collapse } from 'antd';
import ArrowButton from '../../../shared/ArrowButton/ArrowButton';
import './FAQSection.css';
import {
  useNavigate,
} from "react-router-dom";
import { faqItems } from './faqs';
import { getIcon, ICONS } from '../../../icons';
const { Title } = Typography;

import useMobileCheck from '../../../mobile';
import { captureFaqExpanded } from '../../../analytics';
import { useLocation } from 'react-router-dom';

const FAQSection = ({ full = false, pricing = false, hasBackground = true }) => { 
  
  const [ faqs, setFaqs ] = useState([]);
  const { isMobile } = useMobileCheck();
  const naviagate = useNavigate();
  const location = useLocation();
  useEffect (() => { 
    let faqsToShow = faqItems;
    if ( !full ) { 
      faqsToShow = faqItems.filter ( (f) => f.primary ); // only show primary ones when its a small widget.
    }
    if ( pricing ) { 
      faqsToShow = faqsToShow.filter ( (f) => f.finance );
    }
    faqsToShow = faqsToShow.map ( (f) => { 
      let faq = { 
        ...f
      }
      delete faq.primary;
      delete faq.finance;
      return faq;
    })
    setFaqs(faqsToShow);
  }, [full, pricing])

  return (
    <section className="faq-wrapper">
      <Row
        className={ `faq-inner ${hasBackground ? '' : 'faq-inner-no-bg' }` }
        justify="space-between"
        align="top"
        gutter={[48, 48]}
        style={{ 
          paddingLeft: isMobile ? '10px' : '20px',
          paddingRight: isMobile ? '10px' : '20px',
          marginLeft: isMobile ? '20px' : '40px',
          marginRight: isMobile ? '20px' : '40px'
        }}
      >
        <Col xs={24} sm={8} className="faq-left">
          <Title className="faq-title">Frequently Asked <br></br>Questions</Title>
          { ( !full || pricing ) && <ArrowButton onClick={() => { 
            naviagate("/faq")
            document.getElementById('root').scrollTo(0, 0);
          }}>Read More FAQs</ArrowButton> }
        </Col>

        <Col xs={24} sm={16} className="faq-right">
          <Collapse
            accordion
            defaultActiveKey="1"
            bordered={false}
            items={faqs}
            onChange={(activeKey) => {
              const expandedKey = Array.isArray(activeKey) ? activeKey[0] : activeKey;
              if (expandedKey) {
                captureFaqExpanded(location.pathname, String(expandedKey));
              }
            }}
            expandIconPosition="end"
            expandIcon={({ isActive }) => { 
              return getIcon(ICONS.CHEVRON_DOWN, false, {
                rotate : isActive ? 180 : 0
              })
            }}
            className="faq-collapse"
          />
        </Col>
      </Row>
    </section>
  );
}

export default FAQSection;
